import { render, staticRenderFns } from "./LuqapayCommunityDeposit.vue?vue&type=template&id=37f9aebe"
import script from "./LuqapayCommunityDeposit.vue?vue&type=script&lang=js"
export * from "./LuqapayCommunityDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports